export const Last_Net = 'Last_Net'

export const setLocalStorage = (k, v) => {
  localStorage.setItem(k, v)
}

export const getLocalStorage = (k) => {
  return localStorage.getItem(k)
}